<a [routerLink]="{cxRoute:'product',params:product}|cxUrl" class="cx-product-image-container" tabindex="-1">
  <cx-media class="cx-product-image" [container]="product.images?.PRIMARY || product.images" format="product"
    [alt]="product.summary"></cx-media>
</a>

<div class="product-list cross-re-list">
  @if (product && product.pdpLinkFlag) {
  <div class="compare_checkbox"></div>
  }

  <a [routerLink]="{cxRoute:'product',params:product}|cxUrl" class="cx-product-name">
    <label class="product-code" [innerHtml]="product.code | searchHighlight:searchQuery"></label>
  </a>

  @if (product.productReferences) {
  <label>
    {{'common.pdp_information_replacedby' | cxTranslate}}
    <span [innerHtml]="product.productReferences | searchHighlight:searchQuery"></span>
  </label>
  }

  <label class="label-style" [innerHtml]="product.name | searchHighlight:searchQuery"></label>

  @if (product?.sapEan) {
  <label class="label-style">
    GTIN : <span [innerHtml]="product.sapEan | searchHighlight:searchQuery"></span>
  </label>
  }

  <label class="label-style"
    [ngClass]="product.salesStatusCode?.toLowerCase() === 'code30' || product.salesStatusCode?.toLowerCase() === 'code40' ? 'green-color' : ''">
    @if (product.salesStatusText?.indexOf('common.') < 0) { <span
      [innerHtml]="product.salesStatusText | searchHighlight:searchQuery"></span>
      }
      @if (product.salesStatusText?.indexOf('common.') > -1) {
      <span>
        @if (product.salesStatusText) {
        <span>{{product.salesStatusText | cxTranslate}}</span>
        }
      </span>
      }
  </label>

  @if (product?.marketType) {
  <label class="label-style" [innerHtml]="product.marketType | searchHighlight:searchQuery"></label>
  }

  @if (product?.replacedByProductCode) {
  <label class="replaced-by-product">
    <span class="label-style">{{product.replaceByText | cxTranslate}}</span>
    <a class="replaceByText" [href]="product.replacedByPDPUrl"
      [innerHtml]="product.replacedByProductCode | searchHighlight:searchQuery"></a>
  </label>
  }

  @if (product?.imppList[0]?.split(':')[0]) {
  <label class="d-flex">
    <span class="label-style">{{product.imppText | cxTranslate}}</span>
    @if (product?.imppList[0]?.split(':')[2] === 'false') {
    <span class="imp-value m-l" [innerHtml]="product.imppList[0].split(':')[0] | searchHighlight:searchQuery"></span>
    }
    @if (product?.imppList[0]?.split(':')[2] === 'true') {
    <a class="imp-value m-l" [href]="product.imppList[0].split(':')[1]"
      [innerHtml]="product.imppList[0].split(':')[0] | searchHighlight:searchQuery"></a>
    }
  </label>
  }

  @if (product.crossReference[0]?.target) {
  <label class="label-bold-text">
    <span>{{'common.search_page_xref_number' | cxTranslate}}:</span>
    <span [innerHtml]="product.crossReference[0].target | searchHighlight:searchQuery"></span>
  </label>
  }

  @if (product.crossReference[0]?.webName) {
  <label class="label-bold-text m-b">
    <span>{{'common.search_page_xref_name' | cxTranslate}}:</span>
    <span [innerHtml]="product.crossReference[0].webName | searchHighlight:searchQuery"></span>
  </label>
  }

  @if (product.customerPriceText || product.listPriceText || product.netPriceText || product.coreDepositeText) {
  <div class="price-outer" [ngClass]="isLoggedIn ? 'user-logged' : 'user-not-logged'">
    @if (product.customerPriceText) {
    <label class="label-style d-flex justify-content-between">
      {{product.customerPriceText | cxTranslate}}&nbsp;
      @if (!product.listPrice?.formattedValue) {
      <span class="font-bold">
        @if (product.customerPriceText) {
        <span>{{'common.basket_page_poa' | cxTranslate}}</span>
        }
      </span>
      }
      @if (product.listPrice?.formattedValue) {
      <span class="font-bold">
        {{product.listPrice.formattedValue}}&nbsp;{{product.listPrice.currencyIso}}
      </span>
      }
    </label>
    }
    @if (product.listPriceText) {
    <label class="label-style d-flex justify-content-between">
      {{product.listPriceText | cxTranslate}}&nbsp;
      @if (!product.listPrice?.formattedValue) {
      <span class="font-bold">
        @if (product.priceOnRequestText) {
        <span>{{product.priceOnRequestText | cxTranslate}}</span>
        }
      </span>
      }
      @if (product.listPrice?.formattedValue) {
      <span class="font-bold">
        {{product.listPrice.formattedValue}}&nbsp;{{product.listPrice.currencyIso}}
      </span>
      }
    </label>
    }
    @if (product.netPriceText) {
    <label class="label-style d-flex justify-content-between">
      {{product.netPriceText | cxTranslate}}&nbsp;
      @if (!product.netPrice?.formattedValue) {
      <span class="font-bold">
        @if (product.priceOnRequestText) {
        <span>{{product.priceOnRequestText | cxTranslate}}</span>
        }
      </span>
      }
      @if (product.netPrice?.formattedValue) {
      <span class="font-bold">
        {{product.netPrice.formattedValue}}&nbsp;{{product.netPrice.currencyIso}}
      </span>
      }
    </label>
    }
    @if (product.coreDepositeText) {
    <label class="label-style d-flex justify-content-between">
      {{product.coreDepositeText | cxTranslate}}&nbsp;
      @if (!product.corePrice?.formattedValue) {
      <span class="font-bold">
        @if (product.priceOnRequestText) {
        <span>{{product.priceOnRequestText | cxTranslate}}</span>
        }
      </span>
      }
      @if (product.corePrice?.formattedValue) {
      <span class="font-bold">
        {{product.corePrice.formattedValue}}&nbsp;{{product.corePrice.currencyIso}}
      </span>
      }
    </label>
    }
  </div>
  }

  <app-check-box-compare [product]="product"></app-check-box-compare>

  @if (isLoggedIn && product.isCheckAvailibility) {
  <button (click)="checkAvailability(product.code)" class="fs-16 btn btn-secondary btn-block check-avl check-avl-btn">
    {{'common.check_availability_btn_text' | cxTranslate}}
  </button>
  }

  <app-kb-add-to-cart [showQuantity]="false" [purchasable]="product.isAddToCart" class="check-avl add-to-cart-btn"
    [productCode]="product?.code"></app-kb-add-to-cart>

  @if (isLoggedIn && product.isQoute) {
  <button class="btn btn-primary btn-block check-avl">
    {{'common.quote_create' | cxTranslate}}
  </button>
  }

  @if (product.isContactUs && isLoggedIn && !product.isQoute) {
  <a [href]="product?.contactUsUrl" target="_blank" class="btn btn-primary btn-block check-avl">
    {{'common.pdp_page_contact_us' | cxTranslate}}
  </a>
  }

  @if (product.isEnqury && isLoggedIn) {
  <button class="btn btn-primary btn-block check-avl else">
    {{'common.pdp_page_contact_enquiry' | cxTranslate}}
  </button>
  }
</div>

<ng-template [cxOutlet]="ProductListOutlets.ITEM_ACTIONS">
  <ng-container cxInnerComponentsHost></ng-container>
</ng-template>